// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pseudo-console_pseudo-console-wrapper_WAwjj {
    font-family: monospace;
    display: flex;
    flex-direction: column;
    background-color: black;
    color: white;
    overflow-x: hidden;
    overflow-y: scroll;
    overflow-wrap: anywhere;
    white-space: break-spaces;
}
`, "",{"version":3,"sources":["webpack://./src/components/dash-pseudo-console/pseudo-console.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;AAC7B","sourcesContent":[".pseudo-console-wrapper {\n    font-family: monospace;\n    display: flex;\n    flex-direction: column;\n    background-color: black;\n    color: white;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    overflow-wrap: anywhere;\n    white-space: break-spaces;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `pseudo-console_pseudo-console-wrapper_WAwjj`;
export { _1 as "pseudo-console-wrapper" };
export var pseudoConsoleWrapper = `pseudo-console_pseudo-console-wrapper_WAwjj`;
export default ___CSS_LOADER_EXPORT___;
